import React, { JSX, Suspense } from 'react';
import { generatePath, Route } from 'react-router-dom';
import { QueryLoadingAbsolute } from '@ankr.com/raas-ui';
import { lazily, tCommon } from '@ankr.com/raas-utils';
import { createRouteConfig } from '@ankr.com/utils/createRouteConfig';

import { AuthGuard } from '../guards';
import { AccountInfoGuard } from '../guards/AccountInfoGuard';
import { LayoutDefault } from '../layout/components/LayoutDefault';

const { Billing } = lazily(() => import('./screens/Billing'));

const PATH = '/billing';

interface IBillingItemRouteProps {
  rollupUuid: string;
}

export const BillingRoutesConfig = createRouteConfig(
  {
    Billing: {
      path: PATH,
      generatePath: () => generatePath(PATH),
    },
    BillingItem: {
      path: PATH,
      generatePath: ({ rollupUuid }: IBillingItemRouteProps) =>
        generatePath(`${PATH}/?rollupUuid=${rollupUuid}`),
    },
  },
  PATH,
);

export function getBillingRoutes(): JSX.Element {
  return (
    <Route
      path={BillingRoutesConfig.root}
      element={
        <LayoutDefault title={tCommon('page-title.billing')}>
          <AuthGuard>
            <AccountInfoGuard>
              <Suspense fallback={<QueryLoadingAbsolute />}>
                <Billing />
              </Suspense>
            </AccountInfoGuard>
          </AuthGuard>
        </LayoutDefault>
      }
    />
  );
}
